import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';

export function AdvisorWarningDialog({
  children,
  title,
  message,
  onContinue,
}: {
  children?: React.ReactNode;
  title?: string;
  message: string;
  onContinue: () => void;
}) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-lg !font-medium text-gray-700">
            {title ?? 'Quick Note'}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-gray-700">{message}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="text-gray-700">Back</AlertDialogCancel>
          <AlertDialogAction
            className="bg-primary hover:bg-primary-hover text-white"
            onClick={onContinue}
          >
            Proceed
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
